// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1115": "e561263a","2312": "51bf1d16","2791": "787b914a","3993": "3f525799","421": "f048511f","7141": "cdec85e3","9225": "853887f0",}[chunkId] + ".css"
}